import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../services/auth/login.service';
import { environment } from 'src/environments/environment';

export const AuthGuard = () => {
  const authService = inject(LoginService);

  if (authService.isLoggedIn()) {
    return true;
  }

  // Redirect to the login page
    authService.logout();

    return false;
};
